module.exports = __webpack_public_path__ + "static/media/hybriq_1140x200.c99c21b6.png";